<div>
  <div class="t-and-c relative py-4">
    <h1>{{ 'termsAndConditions.title' | transloco }}</h1>
    <h4>{{ 'termsAndConditions.lastAmended' | transloco }}</h4>
    <ol class="flat">
      <li>
        <h2>{{ 'termsAndConditions.whatTermsCoverHeading' | transloco }}</h2>
        <ol class="flat">
          <li>
            <p>
              <b>{{ 'termsAndConditions.whatTermsCoverBold' | transloco }}</b> {{ 'termsAndConditions.whatTermsCoverBody' | transloco }}
            </p>
          </li>
          <li>
            <p>
              {{ 'termsAndConditions.reservedRight' | transloco }}
            </p>
          </li>
        </ol>
      </li>
      <li>
        <h2>{{ 'termsAndConditions.aboutUsHeading' | transloco }}</h2>
        <ol class="flat">
          <li><b>{{ 'termsAndConditions.aboutUsBold' | transloco }}</b> {{ 'termsAndConditions.aboutUsBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.contactUsBold' | transloco }}</b>
            {{ 'termsAndConditions.contactUsBody' | transloco }}
            <a href="mailto:hub@jcb.com">{{ 'termsAndConditions.contactUsEmail' | transloco }}</a></li>
        </ol>
      </li>
      <li>
        <h2>{{ 'termsAndConditions.changesToTermsHeading' | transloco }}</h2>
        {{ 'termsAndConditions.changesToTermsBody' | transloco }}
      </li>
      <li>
        <h2>{{ 'termsAndConditions.generalDisclaimerHeading' | transloco }}</h2>
        <ol class="flat">
          <li><b>{{ 'termsAndConditions.generalDisclaimerBold' | transloco }}</b>
            {{ 'termsAndConditions.generalDisclaimerBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.suspensionOrDiscontinuanceBold' | transloco }}</b>
            {{ 'termsAndConditions.suspensionOrDiscontinuanceBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.contentBold' | transloco }}</b>
            {{ 'termsAndConditions.contentBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.comparatorDataBoldStart' | transloco }}</b>
            {{ 'termsAndConditions.comparatorDataBody' | transloco }}
            <b>{{ 'termsAndConditions.comparatorDataBoldEnd' | transloco }}</b></li>
          <li><b>{{ 'termsAndConditions.dataBold' | transloco }}</b>
            {{ 'termsAndConditions.dataBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.limitationOfLiabilityBold' | transloco }}</b>
            {{ 'termsAndConditions.limitationOfLiabilityBody' | transloco }}
          </li>
        </ol>
      </li>
      <li>
        <h2>{{ 'termsAndConditions.registrationHeading' | transloco }}</h2>
        <ol class="flat">
          <li><b>{{ 'termsAndConditions.registrationIdBold' | transloco }}</b>
            {{ 'termsAndConditions.registrationIdBody' | transloco }}
            <a href="mailto:hub@jcb.com"> {{ 'termsAndConditions.contactUsEmail' | transloco }}</a>.
          </li>
          <li><b>{{ 'termsAndConditions.transferOfRegistrationBold' | transloco }}</b>
            {{ 'termsAndConditions.transferOfRegistrationBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.terminationOfAccessBold' | transloco }}</b>
            {{ 'termsAndConditions.terminationOfAccessBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.terminationOfUserAccessBold' | transloco }}</b>
            {{ 'termsAndConditions.terminationOfUserAccessBody' | transloco }}
            <a href="mailto:hub@jcb.com">{{ 'termsAndConditions.contactUsEmail' | transloco }}</a>
            {{ 'termsAndConditions.or' | transloco }}
            <a href="it.security@jcb.com">{{ 'termsAndConditions.securityEmail' | transloco }}</a></li>
          <li><b>{{ 'termsAndConditions.consequencesOfTerminationBold' | transloco}}</b>
            {{ 'termsAndConditions.consequencesOfTerminationBody' | transloco }}
          </li>
        </ol>
      </li>
      <li>
        <h2>{{ 'termsAndConditions.intellectualPropertyHeading' |  transloco }}</h2>
        <ol class="flat">
          <li><b>{{ 'termsAndConditions.jcbOwnershipBold' | transloco }}</b>
            {{ 'termsAndConditions.jcbOwnershipBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.noCopyingBold' | transloco }}</b>
            {{ 'termsAndConditions.noCopyingBody' | transloco }}
          </li>
        </ol>
      </li>
      <li>
        <h2>{{ 'termsAndConditions.yourObligationsHeading' | transloco }}</h2>
        <ol class="flat">
          <li><b>{{ 'termsAndConditions.prohibitionsBold' | transloco }}</b>
            {{ 'termsAndConditions.prohibitionsBodyHeader' | transloco }}
            <div>
              <ol class="alpha">
                <li>{{ 'termsAndConditions.prohibitionsBodyIllegal' | transloco }}</li>
                <li>{{ 'termsAndConditions.prohibitionsBodyDistribute' | transloco }}</li>
                <li>{{ 'termsAndConditions.prohibitionsBodyImpaired' | transloco }}</li>
                <li>{{ 'termsAndConditions.prohibitionsBodyViolation' | transloco }}</li>
                <li>{{ 'termsAndConditions.prohibitionsBodyUnauthorised' | transloco }}</li>
                <li>{{ 'termsAndConditions.prohibitionsBodyAutomated' | transloco }}</li>
                <li>{{ 'termsAndConditions.prohibitionsBodyBypass' | transloco }}</li>
                <li>{{ 'termsAndConditions.prohibitionsBodyThirdParty' | transloco }}</li>
              </ol>
            </div>
          </li>
          <li><b>{{ 'termsAndConditions.synchronisationBold' | transloco }}</b>
            {{ 'termsAndConditions.synchronisationBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.indemnityBold' | transloco }}</b>
            {{ 'termsAndConditions.indemnityBody' | transloco }}
          </li>
        </ol>
      </li>
      <li>
        <h2>{{ 'termsAndConditions.linksHeading' | transloco }}</h2>
        <ol class="flat">
          <li><b>{{ 'termsAndConditions.linksBold' | transloco }}</b>
            {{ 'termsAndConditions.linksBody' | transloco }}
          </li>
        </ol>
      </li>
      <li>
        <h2>{{ 'termsAndConditions.otherImportantTermsHeading' | transloco }}</h2>
        <ol class="flat">
          <li><b>{{ 'termsAndConditions.illegalContractBold' | transloco }}</b>
            {{ 'termsAndConditions.illegalContractBody' | transloco}}
          </li>
          <li><b>{{ 'termsAndConditions.whichLawsBold' | transloco}}</b>
            {{ 'termsAndConditions.whichLawsBody' | transloco }}
          </li>
          <li><b>{{ 'termsAndConditions.languageBold' | transloco }}</b>
            <span [innerHTML]="'termsAndConditions.languageBody' | transloco"></span>
          </li>
        </ol>
      </li>
    </ol>
  </div>
  <div class="flex border-t border-grey-300 pt-4 mt-4">
    <button class="bg-jcb font-bold text-grey-800 px-6 py-2 ml-auto rounded-sm cursor-pointer" (click)="acceptAndClose()">{{ 'termsAndConditions.accept' | transloco }}</button>
  </div>
</div>
